export default __webpack_public_path__ + "static/media/Fair Housing.7e1b39f8.png";